import {Injectable} from '@angular/core';
import {Mapper} from '../../../../../core/abstracts/mapper.abstract';
import {VehicleResponse} from '../model/vehicle-response.model';
import {Vehicle} from '../model/vehicle.model';
import {OwnerResponse} from '../../../owners/models/owner-response.model';
import {Owner} from '../../../owners/models/owner.model';
import {VehicleStorage} from '../../../storage/model/storage.model';
import {StorageResponse} from '../../../storage/model/storage-response.model';
import {StorageResponseMapper} from '../../../storage/mapper/storage-response.mapper';
import {PropertyResponse} from '../../../property/model/property-response.model';
import {Property} from '../../../property/model/property.model';
import {PropertyResponseMapper} from '../../../property/mapper/property-response.mapper';
import {toDateTimeHelper} from '../../../../../core/helpers/to-datetime.helper';
import {VehicleOwnersResponseMapper} from '../../../owners/mappers/vehicle-owners-response.mapper';

@Injectable({providedIn: 'root'})
export class VehicleResponseMapper extends Mapper<VehicleResponse, Vehicle> {

  constructor(
    private readonly ownerResponseMapper: VehicleOwnersResponseMapper,
    private readonly storageResponseMapper: StorageResponseMapper,
    private readonly propertyResponseMapper: PropertyResponseMapper) {
    super();
  }

  override map(source: VehicleResponse): Vehicle {
    return new Vehicle(
      source.id,
      source.categoryName,
      this.resolveOwner(source.owner),
      this.resolveStorage(source.storage),
      source.archiveNumber,
      source.documentNumber,
      source.keyNumber,
      toDateTimeHelper(source.returnDate),
      source.returningPerson,
      toDateTimeHelper(source.releaseDate),
      source.receiver,
      this.resolveProperties(source.properties)
    );
  }

  private resolveOwner(ownerResponse: OwnerResponse): Owner {
    return this.ownerResponseMapper.map(ownerResponse);
  }

  private resolveStorage(storageResponse: StorageResponse): VehicleStorage {
    return this.storageResponseMapper.map(storageResponse);
  }

  private resolveProperties(properties: PropertyResponse[]): Property[] {
    return properties.map(property => this.propertyResponseMapper.map(property));
  }
}
